import React from "react";

const ContactInfoCard = () => {
  return (
    <div
      style={{
        // background: "green",
        width: "350px",
        // height: "234px",
        background: "#FFFFFF",
        boxShadow: "3px 4px 4px 4px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
        paddingTop: "32px",
        paddingBottom: "32px",
        paddingLeft: "20px",
      }}
    >
      <h2 style={{ color: "#525257" }}>Abdullah Anwer</h2>
      <p
        style={{
          fontWeight: 500,
          fontSize: "18px",
          color: "#A9A9A9",
        }}
      >
        Executive Director-Registrations
      </p>
      <p>
        <strong>Phone No:</strong>{" "}
        <span style={{ color: "#1976D2" }}>+92 331 288 81 31</span>
      </p>
      <p>
        <strong>Email:</strong>{" "}
        <span style={{ color: "#1976D2" }}>reg.munikxiii@gmail.com</span>
      </p>
      <p>
        <strong>Address:</strong> Institute of Business Administration (IBA),
        Karachi, University Rd, University Of Karachi, Karachi, Karachi City,
        Sindh 75270
      </p>
    </div>
  );
};

export default ContactInfoCard;
